import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import React from 'react';
import Training from '../components/HomePageNew/Training';
const TrainingPageNew = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <Training {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default TrainingPageNew;
